import { pageConfig } from '@/common/service/page-config';
import { BILLING_CYCLE } from '@/common/constants';
import { computedPbxBasePlans, computedCallingPlans ,computedPbxUnconfigCallingPlans } from '@/common/service/computers/plans/pbx';
import { getBasePlanInfo } from '@/common/product';
import { get } from 'lodash';

export default function getPbxBillingCycle(boughtPlans = []) {
  const { period = BILLING_CYCLE.ANNUAL } = pageConfig;
  const boughtPbxBasePlans = computedPbxBasePlans(boughtPlans);
  //zp pro and common area special billing cycle not be configured by plan json api yet
  const UnconfigCallingPlans = computedPbxUnconfigCallingPlans(boughtPlans);
  const boughtCallingPlans = computedCallingPlans(boughtPlans).concat([...UnconfigCallingPlans]);

  // default load pbx billing cycle, if has bought base plan, choose base plan cycle
  const basePlanBillingCycle = get(boughtPbxBasePlans, [0, 'billing_cycle']);
  const isPayAsYouGo = basePlanBillingCycle === BILLING_CYCLE.PAY_AS_YOU_GO;
  const basePlan = get(getBasePlanInfo(), 'plans.0', {});
  const billingCycle = get(
    boughtCallingPlans,
    [0, 'billing_cycle'],
    isPayAsYouGo ? basePlan.billing_cycle || period : basePlanBillingCycle || period,
  );
  return billingCycle;
}

export const getPbxCurrentBillingCycle = (pbxBasePlan, nonPbxBasePlan, defaultBillingCycle = BILLING_CYCLE.ANNUAL) => {
  if (!pbxBasePlan) return;

  if (nonPbxBasePlan) {
    return nonPbxBasePlan?.billing_cycle;
  }

  if (pbxBasePlan?.is_payg) {
    return defaultBillingCycle;
  }

  return pbxBasePlan?.billing_cycle;
}
